import React, { useCallback, useEffect, useState } from "react";
import { Tabs, Box } from "@mantine/core";
import { LevelType } from "src/interfaces/KnowledgeBase";
import ManualUploadForm from "./UploadForms/ManualUploadForm/ManualUploadCreateForm";
import AutoUploadForm from "./UploadForms/AutoUploadForm";
import { showNotification } from "@mantine/notifications";
import { knowledgeBaseService } from "src/services/services/knowledgeBase/knowledgeBase.api";

interface UploadDocsProps {
  onRefresh: () => void;
}

const UploadDocs: React.FC<UploadDocsProps> = (props) => {
  const { onRefresh } = props;

  const [levels, setLevels] = useState<LevelType[]>([]);
  const [activeTab, setActiveTab] = useState<string>("manual");
  const [isLoadingLevels, setIsLoadingLevels] = useState<boolean>(false);

  // Fetch levels only once when component mounts
  useEffect(() => {
    const fetchLevels = async () => {
      try {
        setIsLoadingLevels(true);
        const res = await knowledgeBaseService.getLevels();
        if (res.kind === "ok") {
          setLevels(res.data);
        }
      } catch (err) {
        console.error("Failed to load levels", err);
      } finally {
        setIsLoadingLevels(false);
      }
    };
    fetchLevels();
  }, []);

  const handleUploadSuccess = useCallback((message?: string) => {
    // Don't show notification - drawer will show immediately instead
    onRefresh();
  }, [onRefresh]);

  const handleUploadError = useCallback((error: string) => {
    showNotification({
      title: "Error",
      message: error,
      color: "red",
    });
  }, []);

  return (
    <Tabs value={activeTab} onTabChange={(value) => setActiveTab(value || "manual")} variant="outline">
      <Tabs.List>
        <Tabs.Tab value="manual">Manual Upload</Tabs.Tab>
        <Tabs.Tab value="auto">Auto Upload</Tabs.Tab>
      </Tabs.List>

      <Tabs.Panel value="manual" pt="md">
        {activeTab === "manual" && (
          <Box
            p="md"
            style={{ border: "1px solid #dee2e6", borderRadius: "8px" }}
          >
            <ManualUploadForm
              onSuccess={handleUploadSuccess}
              onError={handleUploadError}
              sharedLevels={levels}
              isLoadingLevels={isLoadingLevels}
            />
          </Box>
        )}
      </Tabs.Panel>

      <Tabs.Panel value="auto" pt="md">
        {activeTab === "auto" && (
          <Box
            p="md"
            style={{ border: "1px solid #dee2e6", borderRadius: "8px" }}
          >
            <AutoUploadForm
              onSuccess={handleUploadSuccess}
              onError={handleUploadError}
              sharedLevels={levels}
              isLoadingLevels={isLoadingLevels}
            />
          </Box>
        )}
      </Tabs.Panel>
    </Tabs>
  );
};

export default UploadDocs;
